module.exports = __webpack_public_path__ + "img/ic_add-table.864cbb0f.svg";